import styles from './Switch.module.css';

interface Props {
  label?: string;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  checked?: boolean;
  className?: string;
  name?: string;
}

export default function Switch({
  onChange,
  label = '',
  disabled = false,
  checked = false,
  className = '',
  name,
}: Props) {
  const handleChange = () => {
    const newValue = !checked;
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className={`${styles.container} ${className}`}>
      <div role="button" tabIndex={0} className={styles.switch} onClick={handleChange} onKeyDown={() => { }}>
        <input type="checkbox" name={name} checked={checked} onChange={() => { }} />
        <span className={styles.slider} />
      </div>
      <p className={`${styles.label} ${(disabled) ? styles.labelDisabled : ''}`}>
        {label}
      </p>
    </div>
  );
}
